import { defineComponent as s, createElementBlock as p, openBlock as m, normalizeClass as c, unref as d, createElementVNode as i, toDisplayString as o } from "vue";
import { EditorClasses as u } from "../../../../styles.js";
const k = ["data-link-id"], C = /* @__PURE__ */ s({
  __name: "ScalarPageLink",
  props: {
    item: {}
  },
  setup(l) {
    const r = l;
    return (e, f) => {
      var t, a, n;
      return m(), p("a", {
        class: c(d(u).PageLink),
        "data-link-id": (t = r.item) == null ? void 0 : t.uid,
        "data-scalar-type": "page-link"
      }, [
        i("span", null, o((a = e.item) == null ? void 0 : a.title), 1),
        i("p", null, o((n = e.item) == null ? void 0 : n.description), 1)
      ], 10, k);
    };
  }
});
export {
  C as default
};
